import { craftJsonClient } from '../lib/api';

function Form(form) {
  const handle = form.getAttribute('data-handle');
  const submitButton = form.querySelector('[type="submit"]');

  function handleError(error) {
    // eslint-disable-next-line no-console
    console.error('error', error);
  }

  function createInput(name, value) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;

    form.appendChild(input);
  }

  function handleSuccess({ hash, csrf }) {
    createInput('formHash', hash);

    const { name, value } = csrf;
    createInput(name, value);
  }

  function getToken() {
    return craftJsonClient(`actions/valo-module/api/token?form=${handle}`)
      .then(handleSuccess)
      .catch(handleError);
  }

  submitButton.setAttribute('disabled', 'disabled');

  getToken().then(() => {
    submitButton.removeAttribute('disabled');
  });
}

export default Form;
